var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBotLoadingAnimation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    width: 198,
    height: 198,
    style: {
      shapeRendering: "auto",
      display: "block"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#1c469d",
    r: 10,
    cy: 50,
    cx: 84
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    keySplines: "0 0.5 0.5 1",
    values: "12;0",
    keyTimes: "0;1",
    calcMode: "spline",
    dur: "0.4716981132075471s",
    repeatCount: "indefinite",
    attributeName: "r"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    values: "#1c469d;#ffcf00;#1c469d;#ffcf00;#1c469d",
    keyTimes: "0;0.25;0.5;0.75;1",
    calcMode: "discrete",
    dur: "1.8867924528301885s",
    repeatCount: "indefinite",
    attributeName: "fill"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#1c469d",
    r: 10,
    cy: 50,
    cx: 16
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    values: "0;0;12;12;12",
    keyTimes: "0;0.25;0.5;0.75;1",
    calcMode: "spline",
    dur: "1.8867924528301885s",
    repeatCount: "indefinite",
    attributeName: "r"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "0s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    values: "16;16;16;50;84",
    keyTimes: "0;0.25;0.5;0.75;1",
    calcMode: "spline",
    dur: "1.8867924528301885s",
    repeatCount: "indefinite",
    attributeName: "cx"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#ffcf00",
    r: 10,
    cy: 50,
    cx: 50
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "-0.4716981132075471s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    values: "0;0;12;12;12",
    keyTimes: "0;0.25;0.5;0.75;1",
    calcMode: "spline",
    dur: "1.8867924528301885s",
    repeatCount: "indefinite",
    attributeName: "r"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "-0.4716981132075471s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    values: "16;16;16;50;84",
    keyTimes: "0;0.25;0.5;0.75;1",
    calcMode: "spline",
    dur: "1.8867924528301885s",
    repeatCount: "indefinite",
    attributeName: "cx"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#1c469d",
    r: 10,
    cy: 50,
    cx: 84
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "-0.9433962264150942s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    values: "0;0;12;12;12",
    keyTimes: "0;0.25;0.5;0.75;1",
    calcMode: "spline",
    dur: "1.8867924528301885s",
    repeatCount: "indefinite",
    attributeName: "r"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "-0.9433962264150942s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    values: "16;16;16;50;84",
    keyTimes: "0;0.25;0.5;0.75;1",
    calcMode: "spline",
    dur: "1.8867924528301885s",
    repeatCount: "indefinite",
    attributeName: "cx"
  })), /*#__PURE__*/React.createElement("circle", {
    fill: "#ffcf00",
    r: 10,
    cy: 50,
    cx: 16
  }, /*#__PURE__*/React.createElement("animate", {
    begin: "-1.4150943396226414s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    values: "0;0;12;12;12",
    keyTimes: "0;0.25;0.5;0.75;1",
    calcMode: "spline",
    dur: "1.8867924528301885s",
    repeatCount: "indefinite",
    attributeName: "r"
  }), /*#__PURE__*/React.createElement("animate", {
    begin: "-1.4150943396226414s",
    keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
    values: "16;16;16;50;84",
    keyTimes: "0;0.25;0.5;0.75;1",
    calcMode: "spline",
    dur: "1.8867924528301885s",
    repeatCount: "indefinite",
    attributeName: "cx"
  })), /*#__PURE__*/React.createElement("g", null))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotLoadingAnimation);
export default __webpack_public_path__ + "static/media/bot-loading-animation.534dbcd11ef80bf45ac48276a3023ade.svg";
export { ForwardRef as ReactComponent };